import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid, Row, Col} from 'react-bootstrap';

import {Wrapper} from 'system/wrapper';
import {Message} from 'components/message';
import Input from 'form/input';
import {ButtonWrap, ButtonDefault} from 'components/buttons';

import {changePassword} from 'redux/actions/auth';
import {not} from "ramda";

const mapDispatchToProps = dispatch => ({
  changePassword: (firstPassword, secondPassword, key) => dispatch(changePassword(firstPassword, secondPassword, key))
})

const mapStateToProps = state => ({
  error: state.auth.get('passwordChangeFail'),
  success: state.auth.get('passwordChangeSuccess')
})

class ChangePassword extends Component {
  state = {
    firstPassword: '',
    secondPassword: '',
    error: false,
    success: false
  }

  changePassword = () => {
    if (!this.state.firstPassword || !this.state.secondPassword){
      this.setState(() => ({ error: 'Заповніть, будь ласка, всі поля' }))
    } else if (this.state.firstPassword !== this.state.secondPassword) {
      this.setState(() => ({ error: 'Введені паролі не співпадають' }))
    } else {
      this.props.changePassword(this.state.firstPassword, this.state.secondPassword, this.props.match.params.key)
    }
  }

  changeFirstPassword = event => {
    event.persist()
    this.setState(() => ({ firstPassword: event.target.value }))
  }

  changeSecondPassword = event => {
    event.persist()
    this.setState(() => ({ secondPassword: event.target.value }))
  }

  renderForm = () => not(this.state.success) &&
    <React.Fragment>
      <Input
        type='password'
        block
        value={this.state.firstPassword}
        onChange={this.changeFirstPassword}
        placeholder="Введіть пароль"
        onFocus={this.handleFocusPassword}
        hasError={Boolean(this.state.error)}
      />
      <Input
        type='password'
        block
        value={this.state.secondPassword}
        onChange={this.changeSecondPassword}
        placeholder="Повторіть введений пароль"
        onFocus={this.handleFocusPassword}
        hasError={Boolean(this.state.error)}
        errMsg={this.generateError(this.state.error)}
      />
      <ButtonWrap>
        <ButtonDefault
          value="Змінити пароль"
          onClick={this.changePassword}
        />
      </ButtonWrap>
    </React.Fragment>

  renderMessage = () => this.state.success &&
    <Message>
      Пароль успішно змінено!
    </Message>

  generateError = (error) => { //TODO: make file with all errors and map on file
    if(!error) return
    let msg = ''
    if (error.non_field_errors && error.non_field_errors[0] === 'A user with this token not found.') {
      msg = 'Користувач не знайдений'
    } else if (typeof error === 'string') {
      msg = error
    } else {
      msg = 'При збереженні даних виникла проблема. Перевірте, будь ласка, всі поля'
    }
    return msg
  }

  handleFocusPassword = () => this.setState(() => ({ error: '' }))

  componentWillReceiveProps (nextProps) {
    this.setState(() => ({ error: nextProps.error, success: nextProps.success }))
  }

  render () {
    return (
      <Wrapper>
        <Grid>
          <Row>
            <Col xs={12} sm={8} smOffset={2} lg={6} lgOffset={3}>
              {this.renderForm()}
              {this.renderMessage()}
            </Col>
          </Row>
        </Grid>
      </Wrapper>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword)



// WEBPACK FOOTER //
// ./src/auth/changePassword.js